<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Stores
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device;

	const types = ['open', 'closed', 'stopped'];
	const types_translated = [
		$format('power_on_default_open', {
			default: 'Open: this {device.category} device will open, when it has power.',
		}),
		$format('power_on_default_close', {
			default: 'Close: this {device.category} device will close, when it has power.',
		}),
		$format('power_on_default_stop', {
			default: 'Stop: this {device.category} device will do nothing, when it has power.',
		}),
	];

	const defaultOptionsNewLayout = [
		{
			title: $format('power_on_default_open_new_layout_title', {
				default: 'Open',
			}),
			description: $format('power_on_default_open_new_layout_description', {
				default: 'Opens the cover when power is restored.',
			}),
		},
		{
			title: $format('power_on_default_close_new_layout_title', {
				default: 'Close',
			}),
			description: $format('power_on_default_close_new_layout_description', {
				default: 'Closes the cover when power is restored.',
			}),
		},
		{
			title: $format('power_on_default_stop_new_layout_title', {
				default: 'Stop',
			}),
			description: $format('power_on_default_stop_new_layout_description', {
				default: 'The cover will do nothing when power is restored.',
			}),
		},
	];
	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	let selected = settings?.[`cover:${device.channel}`].initial_state;
	let cache = selected;
	let loading = false;

	const setDefault = async (state) => {
		selected = state;
	};

	const sentRequest = async () => {
		if (cache !== selected) {
			loading = true;
			const params = {
				id: device.channel,
				config: { initial_state: selected },
			};

			const res: SettingRequest = await gen2Request(device, 'Cover.SetConfig', params);

			if (res.isok) {
				settings[`cover:${device.channel}`].initial_state = selected;
				toast.open({
					type: 'success',
					title:
						$format('power_on_default_scc_toast') || `Power on was changed to ${selected}.`,
				});
				devices_settings.update_devices_settings(id, settings);
				cache = selected;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				selected = cache;
			}
			loading = false;
		}
	};
</script>

{#if $showNewLayout}
	{#each types as type, i}
		<Radio
			class="mb-s"
			size="m"
			{selected}
			value={type}
			on:click={() => setDefault(type)}
			id={`power-on-${type}`}
			info={defaultOptionsNewLayout[i].description}
		>
			{defaultOptionsNewLayout[i].title}
		</Radio>
	{/each}
{:else}
	{#each types as type, i}
		<Radio size="m" {selected} value={type} on:click={() => setDefault(type)} id="radio-cn511ss"
			>{types_translated[i]}</Radio
		>
	{/each}
{/if}
<Button class={$showNewLayout ? 'mt-m' : 'mt-s'} {loading} size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
